export const LOAD_COLUMNS_MODE_CREATING = 'creating';
export const LOAD_COLUMNS_MODE_EDITING = 'editing';
export const LOAD_COLUMNS_MODE_ADDING_COLUMNS = 'adding_columns';

export const MODE_EDITING = 'editing';